import React from 'react';

const Loader = ({ text = 'Loading...', size = 'md', fullPage, className = '' }) => {
  const sizes = { sm: '1rem', md: '2rem', lg: '3rem' };
  const spinnerSize = sizes[size] || sizes.md;

  const content = (
    <div className={`d-flex flex-column align-items-center justify-content-center gap-3 ${className}`}>
      <div className="spinner-border" style={{ width: spinnerSize, height: spinnerSize, color: 'var(--primary, #6C63FF)' }} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      {text && <div className="text-muted small">{text}</div>}
    </div>
  );

  if (fullPage) {
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>{content}</div>;
  }
  return <div style={{ padding: '3rem 1rem' }}>{content}</div>;
};

export default Loader;
